module.exports = __webpack_public_path__ + "site/img/avatar_default_female.c1b19a9f.png";